import { TravelerPaxState } from '@pax/store/reducers/travelers.reducer';
import { UiPaxState } from '@pax/store/reducers/ui';
import { LoyaltyProgramResponse, MarriottEnrollmentResponse } from '@pax/entities/loyalty-program.response';

export const paxFeatureName = 'paxModule';

export type PaxState = Readonly<{
  travelers: TravelerPaxState,
  marriottloyaltyNumber: LoyaltyProgramResponse,
  marriottCreatedAccount: MarriottEnrollmentResponse,
  ui: UiPaxState
}>;
